import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../../app.service';
import {ActivatedRoute} from '@angular/router';
import {ViewportScroller} from '@angular/common';
import { NgZone } from '@angular/core';
import {MediaChange, MediaObserver} from "@angular/flex-layout";

import {Canvas} from "src/app/js/canvas"
import {Subscription} from "rxjs";
import {TextRotate} from "../../js/textRotate";
import {backGroundEnum} from "../../js/backGroundEnum";

declare var $;

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html'
})
export class IndexComponent implements AfterViewInit, OnDestroy {
  private watcher: Subscription;
  private activeMediaQuery = '';
  private canvas: any;
  private textRotate: TextRotate;
  public bubbleRed = false;
  public bubbleValue = 0;

  public bubbleRedExpanse() {
    this.bubbleRed = !this.bubbleRed;
  }
  public bubbleExpanse(value: number) {
    if ( value === this.bubbleValue ) {
      this.bubbleValue = 0;
    } else {
      this.bubbleValue = value;
    }
  }

  constructor(public readonly appService: AppService,
              private readonly route: ActivatedRoute,
              private readonly viewScroller: ViewportScroller,
              private readonly lc: NgZone,
              private mediaObserver: MediaObserver) {
    this.canvas = new Canvas();
    this.textRotate = new TextRotate()
    window.onscroll = () => {
      let st = window.pageYOffset;
      let dir = '';
      if (st > this.lastScrollTop) {
          dir = "down";
      } else {
          dir = "up";
      }
      this.lastScrollTop = st;
      lc.run(() => {
        this.direction = dir;
      });
    };
  }
  private scrollOffset: number;
  private i = 0;
  public headerClass = false;
  public lastScrollTop: number = 0;
  public direction: string = "";

  @HostListener("scroll", ['$event'])
  doSomethingOnInternalScroll($event: Event) {
    // @ts-ignore
    this.scrollOffset = $event.srcElement.children[0].scrollTop;
    if (this.scrollOffset >  this.i) {
      this.headerClass = false;
    } else {
      this.headerClass = true;
    }
    if(this.scrollOffset < 50) {
      this.headerClass = false;
    }
    this.i = this.scrollOffset;
  }

  ngOnDestroy() {
    this.watcher.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.watcher = this.mediaObserver.media$.subscribe((change: MediaChange) => {
      this.activeMediaQuery = change ? `'${change.mqAlias}' = (${change.mediaQuery})` : '';
      if ( change.mqAlias === 'lg' && this.appService.backGroundActive === backGroundEnum["/"]) {
        try {
          $('#effectCanvas').ripples({
            resolution: 240,
            perturbance: 0.01
          });
        }
        catch (e) {
          console.log(e);
        }
      }
    })

    this.textRotate.init();

    this.route.fragment.subscribe(f => {
      setTimeout(function () {
        const element = document.querySelector("#" + f)
        if (element) element.scrollIntoView()
        console.log("ANCLA => #" + f)
      }, 100);
    })
  }
}
